<template>
  <div :data-id="object.label || field">
    <div v-if="object.multiple">
      <multiselect
        style="position: relative; z-index: 200"
        :multiple="true"
        :options="optionsList"
        v-model="mutatedObject[field]"
      />
    </div>
    <select v-else class="form-control" v-model="mutatedObject[field]" :required="object.required">
      <option selected disabled value>Select {{ object.label || field | capitalize }}</option>
      <option v-for="item in optionsList" :value="item[object.value] || item">
        <div v-if="object.displayedFields">
          <span v-for="displayedField in object.displayedFields">{{ item[displayedField] + ' ' }}</span>
        </div>
        <span v-else>{{ item }}</span>
      </option>
    </select>
  </div>
</template>

<script>
import formComponentsMixin from '@/mixins/formComponentsMixin';

export default {
  mixins: [formComponentsMixin],
  computed: {
    optionsList() {
      return (
        (this.object.relations && this.object.relations.data[mutatedObject[this.object.relations.arrayName]]) ||
        this.object.array ||
        []
      );
    }
  }
};
</script>
